import { Locales } from 'intlayer';

export const SUPPORTED_LOCALES = [Locales.ENGLISH] as const;

export type AppLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: AppLocale = Locales.ENGLISH;

export const LOCALE_COOKIE_NAME = 'trypillian-locale';

export function isAppLocale(locale: string | undefined): locale is AppLocale {
  return (SUPPORTED_LOCALES as readonly string[]).includes(locale ?? '');
}
